export function isObjectLiteral(obj) {
  return obj !== null &&
    typeof obj === 'object' &&
    Object.getPrototypeOf(obj) === Object.prototype;
}
